/**
 * How-to guide for new users: accepting an invitation and signing up.
 * Public page - accessible without signing in.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const HowToPage = () => {
  const { isSignedIn } = useUser();

  return (
  <div className="entry-page" style={{ maxWidth: '640px', margin: '0 auto', textAlign: 'left' }}>
    <div style={{ padding: '1.5rem 1rem 4rem', background: 'var(--cr-bg)' }}>
      <h1 style={{ marginTop: 0, marginBottom: '0.25rem', fontSize: '1.75rem' }}>How to Get Started</h1>
      <p style={{ color: 'var(--cr-text-muted)', marginBottom: '0.5rem', fontSize: '0.95rem', fontWeight: 600 }}>
        Invitation &amp; sign up
      </p>
      <p style={{ color: 'var(--cr-text-muted)', marginBottom: '2rem', fontSize: '0.95rem' }}>
        New to Ministry Data Portal? Follow these steps to accept your invitation and create your account.
      </p>

      <div style={{ background: 'var(--cr-surface)', padding: '2rem', borderRadius: '12px', border: '1px solid var(--cr-border)' }}>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.2rem', marginBottom: '0.75rem' }}>1. Check your email</h2>
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            You should receive an email with the subject <strong>&ldquo;Your invitation to Ministry Data Portal&rdquo;</strong>.
            The email is sent from your administrator when they add you to the portal.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.2rem', marginBottom: '0.75rem' }}>2. Click Accept invitation</h2>
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            Open the email and click the <strong>Accept invitation</strong> button. This link will take you to the sign-up page.
            If you use the link from the email, your invitation will be applied automatically when you create your account.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.2rem', marginBottom: '0.75rem' }}>3. Create your account</h2>
          <p style={{ margin: 0, lineHeight: 1.6, marginBottom: '0.5rem' }}>
            On the sign-up page, enter the <strong>same email address</strong> that received the invitation, then create a password.
            Complete the form and click to create your account.
          </p>
          <p style={{ margin: 0, lineHeight: 1.6, color: 'var(--cr-text-muted)', fontSize: '0.95rem' }}>
            If you already have an account, click <strong>Sign in</strong> instead and use your existing email and password.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.2rem', marginBottom: '0.75rem' }}>4. You&apos;re in</h2>
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            After signing in, you&apos;ll see the Home page with the sections you have access to. Your administrator
            assigns which parts of the portal you can use (e.g., Add Group Data, Reports, Step Study).
          </p>
        </section>

        <section style={{ marginBottom: '0', paddingTop: '1.5rem', borderTop: '1px solid var(--cr-border)' }}>
          <h2 style={{ fontSize: '1.1rem', marginBottom: '0.75rem' }}>Having trouble?</h2>
          <ul style={{ paddingLeft: '1.25rem', margin: 0, lineHeight: 1.7 }}>
            <li><strong>Can&apos;t find the email?</strong> Check your spam or junk folder. Ask your administrator to resend the invitation.</li>
            <li><strong>Link says expired?</strong> Invitations expire after 30 days. Ask your administrator to send a new invitation.</li>
            <li><strong>Wrong email?</strong> Use the same email address that received the invitation. If you need a different email, ask your administrator to invite that address instead.</li>
          </ul>
        </section>
      </div>

      <div style={{ marginTop: '2rem', textAlign: 'center' }}>
        {isSignedIn ? (
          <Link
            to="/"
            style={{
              display: 'inline-block',
              padding: '0.65rem 1.5rem',
              background: 'var(--cr-button)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 600,
              fontSize: '1rem',
            }}
          >
            Back to Home
          </Link>
        ) : (
          <>
            <Link
              to="/sign-up"
              style={{
                display: 'inline-block',
                padding: '0.65rem 1.5rem',
                background: 'var(--cr-button)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '1rem',
              }}
            >
              Go to Sign up
            </Link>
            <span style={{ margin: '0 0.75rem', color: 'var(--cr-text-muted)' }}>or</span>
            <Link
              to="/sign-in"
              style={{
                color: 'var(--cr-link)',
                textDecoration: 'underline',
                fontSize: '1rem',
              }}
            >
              Sign in
            </Link>
          </>
        )}
      </div>
    </div>
  </div>
  );
};

export default HowToPage;
